import React from "react";
import { Clock, GraduationCap, ArrowRight, Check } from "lucide-react";
import { courses } from "../mock";

export default function Courses({ onEnroll }) {
  return (
    <section id="courses" className="section-cream py-20 md:py-28 relative overflow-hidden">
      <div className="blob blob-yellow w-96 h-96 -top-24 -left-16" />
      <div className="blob blob-cyan w-80 h-80 bottom-10 -right-10" />
      <div className="max-w-7xl mx-auto px-5 md:px-8 relative z-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <div className="text-[#B45309] text-xs font-black tracking-[0.3em] uppercase">Our Courses</div>
            <h2 className="section-title mt-3 text-4xl md:text-5xl font-black brand-navy">
              Seven signature programs. <span className="gold-gradient">One future-ready you.</span>
            </h2>
          </div>
          <p className="text-[#0A1740]/60 md:max-w-sm">
            Choose from creative, communication and career-focused tracks. Every course is designed for real-world outcomes.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {courses.map((c) => (
            <article
              key={c.id}
              className="course-card group relative rounded-3xl overflow-hidden flex flex-col"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={c.image}
                  alt={c.title}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div
                  className="absolute inset-0"
                  style={{
                    background: `linear-gradient(180deg, rgba(10,23,64,0.05) 0%, rgba(10,23,64,0.85) 100%)`,
                  }}
                />
                <div className="absolute left-4 top-4 flex items-center gap-2">
                  <span
                    className="px-2.5 py-1 rounded-full text-[10px] uppercase tracking-widest font-black"
                    style={{ background: c.accent, color: "#0a1740" }}
                  >
                    {c.level}
                  </span>
                </div>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-2xl font-extrabold text-white leading-tight drop-shadow">{c.title}</h3>
                </div>
              </div>

              <div className="p-6 flex flex-col flex-1">
                <p className="text-sm text-[#0A1740]/75 leading-relaxed">{c.subtitle}</p>

                <ul className="mt-4 space-y-2">
                  {c.highlights.map((h) => (
                    <li key={h} className="flex items-start gap-2 text-sm text-[#0A1740]/85">
                      <Check className="text-[#F59E0B] mt-0.5 shrink-0" size={16} />
                      <span>{h}</span>
                    </li>
                  ))}
                </ul>

                <div className="mt-5 flex items-center gap-4 text-xs text-[#0A1740]/55 pt-4 border-t border-[#0A1740]/10">
                  <span className="inline-flex items-center gap-1.5">
                    <Clock size={14} /> {c.duration}
                  </span>
                  <span className="inline-flex items-center gap-1.5">
                    <GraduationCap size={14} /> Certificate
                  </span>
                </div>

                <button
                  onClick={() => onEnroll?.(c.title)}
                  className="mt-5 inline-flex items-center justify-between px-4 py-2.5 rounded-full bg-[#FFF3D6] hover:bg-[#F59E0B] hover:text-[#0A1740] text-[#0A1740] text-sm font-bold transition-colors"
                >
                  Enquire Now <ArrowRight size={16} />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
